import type { TerminalToCampaignDto } from "src/app/features/Campaign/types/TerminalToCampaignDto";
import type { TerminalToCampaignEntity } from "src/app/features/Campaign/types/TerminalToCampaignEntity";

export const TerminalToCampaignEntityToDto = (terminalToCampaign: Readonly<TerminalToCampaignEntity>): TerminalToCampaignDto => {
    const updatedTerminalToCampaign: TerminalToCampaignEntity = { ...terminalToCampaign };

    if (!updatedTerminalToCampaign.terminal) {
        updatedTerminalToCampaign.terminal = updatedTerminalToCampaign.id as number;
    }

    return updatedTerminalToCampaign;
};
